const currentYear = new Date().getFullYear();
const texts = {
  romania: {
    native: {
      navigation: {
        login: {
          login: 'Autentificare',
          loginLink: 'https://affiliates.pariuriplus.ro/login',
        },
        registration: {
          registrationIframe:
            'https://affiliates.pariuriplus.ro/embedded-register?id=abb9e205aab64330a9cd5a21465bf034',
          registrationLink:
            'https://affiliates.pariuriplus.ro/embedded-register?id=abb9e205aab64330a9cd5a21465bf034',
        },
        navigationLinks: {
          home: 'Home',
          aboutUs: 'Despre noi',
          whatWeOffer: 'Producse',
          testimonials: 'Testimonial',
          contact: 'Contactați-ne',
          rewardTiers: 'Comisioane',
          faq: 'FAQ',
          terms: 'Termene & Condiții',
        },
      },
      footer: {
        sponsors: 'Sponsor Oficial',
        socialMedia: 'Social Media',
        socialLink: {
          facebook: 'https://www.facebook.com/profile.php?id=61560782754992',
          instagram: 'https://www.instagram.com/pariuriplus/',
          youtube: 'https://www.youtube.com/@pariuriplus-1',
        },
        copyright: `© ${currentYear} pariuriplus este o marcă înregistrată. Toate drepturile rezervate.`,
      },
      homePage: {
        hero: {
          title: ['Transformă-ți audiența în'],
          typing: ['parteneri.', 'venit.', 'afacere.'],
          cta: 'Înregistrare',
        },
        steps: {
          title: 'Ești la 3 pași de primul tău comision',
          steps: [
            {
              iconUrl: '',
              title: 'Înregistrare',
              p: 'Tot ce trebuie să faci este să completezi detaliile tale în pagina de "Înregistrare" și să trimiți formularul. ',
              link: {
                text: 'Înregistrează-te acum!',
                href: '/register',
              },
            },
            {
              iconUrl: '',
              title: 'Obține aprobarea',
              p: 'Solicitarea ta va fi evaluată de către echipa noastră de afiliere și, dacă întrunești condițiile, vei fi acceptat.',
            },
            {
              iconUrl: '',
              title: 'Obține venituri',
              p: 'După ce ai fost acceptat în programul de afiliere, poţi să începi să promovezi pariuriplus şi să obţii câştiguri imediate.',
            },
          ],
        },
        aboutUs: {
          title: 'Despre noi',
          paragraphs: [
            'Echipa de afiliere pariuriplus dispune de cunoștințe aprofundate de marketing afiliat și își propune să ofere un suport de înalt nivel profesional partenerilor săi.',
            'Echipa pariuriplus este formată din specialiști ale căror cunoștințe s-au fundamentat de-a lungul multor ani de experiență  în industria jocurilor de noroc online și de marketing afiliat. Acest lucru constituie un "pariu sigur" pentru fiecare partener care ar dori să coopereze cu pariuriplus.',
          ],
          subtitle: 'Principiile echipei noastre',
          list: [
            'Program de afiliere de top, generator de venituri',
            'Până la 50% cota de comision din venituri, care se aplică la toate produsele pariuriplus',
            'Abordare locală pentru clienți și afiliaţi, cu suport în 4 limbi diferite',
            'Cunoaștere profundă a fiecărei piețe și a necesităților sale',
            'Echipa noastră vă va oferi cel mai bun sprijin și consultanță, pentru a atinge obiectivele pe care vi le-ați propus să le atingeți prin afiliere și pentru a vă maximiza profitul.',
          ],
        },
        whatWeOffer: {
          title: 'Produse',
          tabTitles: ['Pariuri sportive', 'Cazino'],
          articles: [
            {
              for: 'Pariuri sportive',
              titles: ['Cote competitive', 'Pariuri Live'],
              paragraphs: [
                [
                  'Cotele pariuriplus sunt printre cele mai competitive de pe piață. Acoperim o gamă largă de piețe, de la cele mai mari evenimente globale la ligile locale și sporturi diferite din Europa și din întreaga lume. pariuriplus își propune să asigure tuturor clienților cea mai interesantă ofertă globală și locală.',
                ],
                [
                  'Pariurile live (Live betting) reprezintă una dintre opțiunile cele mai populare pentru clienții noștri și de aceea oferim peste 25.000 de evenimente pe lună, pe tot parcursul anului!',
                ],
              ],
            },
            {
              for: 'Cazino',
              titles: [
                'De ce Cazinoul pariuriplus?',
                'Bonus de bun venit și Promoții',
              ],
              paragraphs: [
                [
                  'Distracția este garantată. Cu cele trei Cazino lobby-uri diferite, plus Cazinoul nostru live cu dealeri live, oferim un portofoliu extins de jocuri, bonusuri generoase de bun venit și promoții în mod regulat. De asemenea, jackpot-urile sunt mari, unele dintre cele mai mari pe care le puteți găsi.',
                  'pariuriplus Cazino oferă cele mai bune jocuri dintre cele existente, de la furnizori de top, cum ar fi NetEnt, Betsoft, PlayNgo, iSoftbet, Evolution Live Casino, Quickspin, Pragmatic Play. Oferim o experiență de tip Cazino online la cel mai înalt nivel, cu cele mai noi jocuri de pe piață, urmărind cele mai recente tendințe. Trei destinații diferite de cazino sunt disponibile pentru crearea unei ideale "lumi de cazinou" virtual. Trăiește online experiența cazinoului real!',
                ],
                [
                  'Bonusul de bun venit al Cazinoului este conceput pentru a da satisfacție oricărui client, de orice naționalitate, de orice preferință și gust. Rotiri gratuite, bonusuri, turnee, toate acestea sunt adesea oferite jucătorilor fideli.',
                ],
              ],
            },
          ],
        },
        testimonials: [
          {
            title: 'Legalbet',
            paragraph:
              '"Colaborarea cu PariuriPlus este unul dintre cele mai solide parteneriate pe care le avem la Legalbet. Ca afiliat orientat pe SEO, calitatea este totul pentru noi și reprezintă un atu de partea lor. Jucătorii pe care îi aducem întâlnesc un brand care convertește bine și îi menține activi, iar echipa rămâne mereu receptivă, de încredere și implicată în rezultatele comune. Recomandăm cu încredere!"',
            linkUrl: 'https://legalbet.ro/',
            linkText: 'legalbet.ro',
          },
          {
            title: 'Best Bookmakers',
            paragraph:
              '"Dacă ești în căutarea unui parteneriat de succes, nu poți da greș cu programul de afiliere pariuriplus. Echipa este foarte prietenoasă și de încredere, mereu gata să ajute. Suntem convinși că vom avea un parteneriat puternic pe termen lung cu ei"',
            linkUrl: 'https://bestbookmakers.co.uk/',
            linkText: 'bestbookmakers.co.uk',
          },
          {
            title: 'bookmakers',
            paragraph:
              '"pariuriplus își pune amprenta pe industria de iGaming și e o adevărată plăcere să colaborezi cu o marcă atât de inovatoare. Oferă o foarte bună rată de conversie și sunt mereu disponibili pentru orice întrebare."',
            linkUrl: 'https://www.bookmakers.bet/',
            linkText: 'www.bookmakers.bet',
          },
          {
            title: 'Topbookmakers',
            paragraph:
              '"pariuriplus este printre companiile de pariuri sportive cu cea mai rapidă creștere din Europa. Recomandăm fără rezerve colaborarea cu această echipă de profesioniști inovatori."',
            linkUrl: 'https://www.topbookmakers.com.cy/',
            linkText: 'www.topbookmakers.com.cy',
          },
          {
            title: 'Feeling Lucky',
            paragraph:
              '"pariuriplus is an established brand in the Romanian market, so we are pleased to promote them on Feeling Lucky. Moreover, we appreciate the initiative their affiliate managers take, from keeping us informed about new bonuses, promotions, etc. to discussing ways to boost our campaign."',
            linkUrl: 'https://feelinglucky.ro/',
            linkText: 'feelinglucky.ro',
          },
        ],
        contactUs: {
          title: 'Contactează-ne',
          button: 'Trimite',
          fields: {
            name: 'Nume',
            surname: 'Prenume',
            email: 'Email',
            message: 'Mesaj',
          },
        },
      },
      termsandconditions: {
        title: ['Termene și Condiții'],
      },
      rewardTiers: {
        title: ['Planuri de recompensă'],
        descriptions: ['Venit net**', 'Cotă venit net'],
        tabTitles: ['Pragul 1', 'Pragul 2', 'Pragul 3', 'Pragul 4'],
        tierArticles: [
          {
            tier: 'Pragul 1',
            amounts: ['0-20 Clienți are efectuează prima depunere', '25 %'],
          },
          {
            tier: 'Pragul 2',
            amounts: ['21-50 Clienți are efectuează prima depunere', '30 %'],
          },
          {
            tier: 'Pragul 3',
            amounts: ['51-100 Clienți are efectuează prima depunere', '35 %'],
          },
          {
            tier: 'Pragul 4',
            amounts: ['100+ Clienți are efectuează prima depunere', '40 %'],
          },
        ],
        disclaimer: '',
        earnings: {
          title: '',
          info: [],
        },
        extras: {
          title: 'Planul de distribuire a veniturilor pe niveluri',
          sections: [
            {
              paragraphs: [
                'În fiecare lună calendaristică, o să câștigați un procent din clienții achiziționați care depun pentru prima dată la pariuriplus.',
                'Procentul din venitul net pe care îl veți primi în fiecare lună depinde de un factor: jucători noi care depun.',
                'Pe baza primei depuneri, jucătorii achiziționați generează venit net, vi se plătește un procent din acesta sub formă de comision. Când achiziționați până la 20 de jucători care depun pentru prima dată într-o lună calendaristică, procentul pe care îl primiți va fi de 25%. Când achiziționați de la 21 la 50 de jucători care depun pentru prima dată într-o lună calendaristică, procentul va fi de 30%. Când achiziționați de la 51 la 100 de clienți care depun pentru prima dată într-o lună calendaristică, procentul va fi de 35%. Când achiziționați mai mult de 100 de jucători care depun pentru prima dată, procentul va fi de 40%',
                'Dacă venitul de la jucătorii tăi este negativ în orice lună, acesta va fi reportat în luna următoare (aceasta este adesea numită report negativ).',
                '**Venitul net este definit după cum urmează: Venitul brut minus costul vânzărilor (cuprinzând taxe, taxe de rețea, taxe de tranzacție, costuri bonus și prime).',
              ],
            },
            {
              title: 'CPA/Recompense hibrid',
              paragraphs: [
                'Dacă ești interesat în a discuta un cost-pe-achiziție (CPA) sau de un plan de recompensă hibrid, te rugăm să contactezi managerul tau de afiliere.',
              ],
            },
            {
              title: 'Opțiuni de plată afiliați',
              paragraphs: [`Transfer bancar`],
            },
          ],
        },
        disclaimer2: '',
      },
      faq: {
        title: ['Întrebări frecvente'],
        sections: [
          {
            title: 'General',
            qanda: [
              {
                question: 'Cum funcționează programul de afiliere pariuriplus?',
                answer: [
                  `Programul de afiliere pariuriplus recompensează terții pentru direcţionarea clienților pe site-ul pariuriplus.`,
                  `Partenerii pariuriplus trimit trafic către site-urile noastre  prin intermediul unor link-uri ce conţin un cod de tracking,  iar atunci când utilizatorii se înregistrează în calitate de clienți , fac depuneri și joacă în platforma pariuriplus, îi recompensăm pe partenerii noştri cu un comision.`,
                ],
              },
              {
                question: 'Ce este un sub-afiliat?',
                answer: [
                  `    Un sub - afiliat este un nou partener (afiliat), pe care îl înscrieți la affiliates.pariuriplus.com. Puteți face acest lucru înscriindu-l prin intermediul link-urilor de afiliere pe  care le veți  găsi în contul dumneavoastră .
                        După înscriere, puteți obține câștiguri suplimentare pentru fiecare client pe care sub - afiliatul dvs. ni-l trimite. Puteți găsi link-ul dvs.  de sub - afiliat sub cuprinsul contului dvs.`,
                ],
              },
            ],
          },
          {
            title: 'Contul meu',
            qanda: [
              {
                question: 'Unde pot verifica statisticile contului meu?',
                answer: [
                  `       Când vă conectați la contul dvs. afiliat pariuriplus, veți avea posibilitatea  de a accesa o gamă largă de rapoarte care detaliază datele care ne-au fost transmise prin intermediul site-ului dvs., inclusiv toate tranzacțiile care au fost efectuate.`,
                  `  Dacă aveți întrebări cu privire la aceste rapoarte, atunci va rugam să folosiți formularul de contact sau să luați legătura direct cu managerul dvs. de afiliere.`,
                ],
              },
              {
                question: 'Cât de des sunt actualizate statisticile mele?',
                answer: [
                  `  Rapoartele în interfața pariuriplus afiliere sunt actualizate zilnic, de obicei la  3pm GMT/4pm BST. În cazul în care credeți că statisticile dvs. nu au fost actualizate sau aveți întrebări, vă rugăm să contactați managerul dvs. de afiliere.`,
                ],
              },
              {
                question: 'Cum sunt conectați utilizatorii la contul meu?',
                answer: [
                  `   Atunci când un client face click de pe un link sau banner  de pe site-ul dvs., codul dvs. unic de urmărire asigură că acel client poate fi asociat doar  contului dumneavoastră .
                        Pentru mai multe informații detaliate cu privire la modul în care funcționează acest lucru, vă rugăm să contactați managerul dvs. de  afiliere.`,
                ],
              },
              {
                question:
                  'Cum pot verifica numărul de utilizatori pe care i-am adus la pariuriplus?',
                answer: [
                  `    În calitate de afiliat, aveți acces la rapoartele clientului , pe care le puteți găsi atunci când vă conectați la contul dumneavoastră. Acest lucru vă va oferi informații cu privire la jucători , dar vă rugăm să fiți conștienți de faptul că informațiile lor personale nu vor fi partajate ca urmare a legislației privind protecția datelor.`,
                ],
              },
              {
                question: 'Există țări care nu pot promova pariuriplus?',
                answer: [
                  `    Jucătorii din următoarele țări nu sunt acceptați la pariuriplus:
                        Statele Unite ale Americii și Franța.`,
                ],
              },
              {
                question: 'Cum pot verifica statisticile sub- afiliaților mei?',
                answer: [
                  `   Rapoartele noastre vă permit să vizualizați numărul de sub- afiliaţi pe care i-ați recrutat și ce câștiguri ați obținut de la ei.`,
                  `Vă rugăm să contactați managerul dvs. de afiliere, dacă aveți orice alte întrebări referitoare la acest lucru.`,
                ],
              },
            ],
          },
          {
            title: 'Instrumente de marketing',
            qanda: [
              {
                question:
                  'Unde pot găsi instrumente de marketing pentru produsele pariuriplus?',
                answer: [
                  `Odată ce contul dvs. de afiliat pariuriplus a fost aprobat, veți putea să vă autentificați și să găsiți o serie de link-uri text, bannere precum şi alte instrumente de promovare în secțiunea " Media Gallery " din interfața  noastră.`,
                ],
              },
              {
                question:
                  'Pot solicita un instrument special de marketing pentru site-ul meu?',
                answer: [
                  `Pot fi făcute stabilite instrumente speciale, exclusive, pentru anumiţi afiliaţo. Pentru a discuta alternativele, contactaţi-l pe managerul Dvs de afiliere.`,
                ],
              },
              {
                question:
                  'Pot oferi vizitatorilor site-ului meu un stimulent să se înscrie?',
                answer: [
                  `Site-ul pariuriplus oferă jucătorilor noi o gamă largă de stimulente. Aceste bonusuri variază în funcție de produsul pe care îl promovați  și piața pe care o vizați. Pentru a verifica cele mai recente promoții pentru produsul  și piața  vizate, vă rugăm să contactați managerul dvs. de afiliere.`,
                ],
              },
              {
                question: 'Oferiți coduri de bonus?',
                answer: [
                  `Da, putem oferi coduri de bonus pentru pariuriplus . Vă rugăm să contactați managerul dvs. de afiliere pentru a solicita unul.`,
                ],
              },
            ],
          },
          {
            title: 'Câștiguri și Plăți',
            qanda: [
              {
                question: 'Care sunt metodele de plată disponibile?',
                answer: [
                  `pariuriplus oferă o serie de metode de plată, inclusiv transfer bancar și Skrill (Moneybookers anterior). Vă rugăm asigurați-vă că opțiunile dvs. de plată sunt ținute la zi în Contul meu > Informații de plată.`,
                ],
              },
              {
                question: 'Când este plătit comisionul meu?',
                answer: [
                  ` Plăţile către partnerii noştri se efectuează în termen de 15 - 20 zile de la cererea de plată, în cazul în care aţi atins limita minimă de 50 de euro. Dacă nu ați ajuns la acest nivel, atunci câștigurile dvs. vor fi reportate în luna următoare.`,
                ],
              },
              {
                question: 'Unde pot vedea câștigurile mele?',
                answer: [
                  `Puteți vizualiza statisticile dvs. în orice moment, prin intermediul Rapoarte > secțiunea Rapoarte  Venituri în interfața  pariuriplus afiliere.`,
                ],
              },
              {
                question: 'Există o limită a câștigurilor mele?',
                answer: [
                  `Nu există nici o limită! Oferim planuri de recompensare  competitive și flexibile, corespunzătoare numarului de jucători pe care ni-i trimiteţi şi calităţii acestora. Pentru mai multe detalii, vă rugăm să contactați managerul dvs. de afiliere.`,
                ],
              },
              {
                question:
                  'Unde pot vedea situația comisionului meu  și alte informații?',
                answer: [
                  `După ce vă conectaţi în contul dvs de afiliat, informațiile dvs. de plată va fi afișate pe pagina principală. Informațiile detaliate pot fi obținute prin click pe " Rapoarte" , "Raport Câștiguri " sau "Raport de plată ".`,
                ],
              },
              {
                question: `Câștigurile  sub–afiliaților sunt plătite la aceeași dată ca și plățile mele periodice?`,
                answer: [
                  `Da, comisionul sub – afiliatului dvs. este plătit împreună cu câștigurile de afiliere obişnuite, în fiecare lună. Puteți vedea  sub - afiliații în Rapoarte > Rapoarte Câștiguri > Sub - Afiliați.`,
                ],
              },
            ],
          },
        ],
      },
    },
  },
};
function languageSelector(data) {
  return texts[data.country][data.language];
}
export default languageSelector;
